
<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>Sipariş Verme Süresi Detayı</h4>
      <v-row style="margin-top:100px;">
        <v-col cols="12" md="4">
          <h4>Başlık</h4>
          <v-text-field
            v-model="timePeriodData.timePeriod"
            :rules="titleRules"
            min="0"
            type="number"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Aktif/Pasif</h4>
          <v-checkbox v-model="timePeriodData.active" color="#4d48f9" ></v-checkbox>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="7">
          <v-btn
            depressed
            color="#4d48f9"
            style="text-transform: none !important;float:right;color:white;"
            @click="timePeriodUpdate()"
          >GÜNCELLE</v-btn>
        </v-col>
      </v-row>

      <v-dialog
              v-model="dialog"
              max-width="600"
      >
        <v-card>
          <v-card-title class="headline">Lütfen alanları kontrol edin</v-card-title>

          <v-card-text>
            <ul>
              <li v-for="errorList in this.errorList" :key="errorList">{{errorList}}</li>
            </ul>
          </v-card-text>

        </v-card>
      </v-dialog>

      <!-- <v-row>
          
      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TimePeriodDetails",
  computed: mapGetters(["timePeriodData"]),
  methods: {
    ...mapActions(["getTimePeriod","updateTimePeriod"]),
    routeTimePeriods() {
      this.$router.push("/dashboard/productCategories/timePeriods");
    },
    timePeriodUpdate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.updateTimePeriod(this.timePeriodData).then(response=>{
          console.log(response)
          if(response.processStatus == "Success") {
           alert("Güncelleme işlemi başarılıdır");
            this.routeTimePeriods();
          }
          else {
            alert(response.friendlyMessage.message);
          }
        });
      }else{
        var errors=[];
        var x = document.getElementsByClassName("v-messages__message");
        for (var i = 0; i < x.length; i++)
          errors.push(x[i].innerHTML);

        this.errorList=errors;

        this.dialog=true;
      }
    }
  },
  data: () => ({
    dialog: false,
    valid: true,
    titleRules: [v => !!v || "Başlık alanı zorunludur."],
    errorList:[]
  }),
  created() {
    let id = this.$route.params.id;

    this.getTimePeriod(id);
  },
};
</script>
